import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-navy text-white overflow-hidden pt-20 pb-24 md:pt-32 md:pb-32" data-id="element-146">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-gold/10 blur-[120px] rounded-full pointer-events-none" data-id="element-147"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-148">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20 max-w-7xl mx-auto" data-id="element-149">
          {/* Text Content */}
          <motion.div className="flex-1 text-center lg:text-left" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-150">
            <motion.div className="inline-block px-4 py-1.5 rounded-full border border-gold/30 bg-gold/10 text-gold text-sm font-medium tracking-wider mb-6" initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} data-id="element-151">
              IA EXPRESS 2026
            </motion.div>

            <motion.h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3,
            duration: 0.6
          }} data-id="element-152">
              Lanza tu mini-negocio visual desde tu celular en{' '}
              <span className="text-gold italic" data-id="element-153">48 horas</span>
            </motion.h1>

            <motion.p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed font-light" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} data-id="element-154">
              La guía práctica para mujeres que quieren generar ingresos con
              estrategias de Inteligencia Artificial, aunque hoy no tengan
              experiencia técnica, mucho tiempo o una ruta clara para empezar.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 0.6
          }} className="flex flex-col items-center lg:items-start gap-4" data-id="element-155">
              <CTAButton text="QUIERO EMPEZAR AHORA" href="#pricing" data-id="element-156" />
              <p className="text-sm text-slate-400 mt-2" data-id="element-157">
                Empieza desde cero, a tu ritmo y usando solo tu celular.
              </p>
            </motion.div>
          </motion.div>

          {/* Image */}
          <motion.div className="flex-1 w-full max-w-lg lg:max-w-none relative" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.6,
          duration: 0.8
        }} data-id="element-158">
            <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/10" data-id="element-159">
              <div className="absolute inset-0 bg-gradient-to-tr from-navy/40 to-transparent mix-blend-overlay z-10" data-id="element-160"></div>
              <img src="https://cdn.magicpatterns.com/uploads/smmxZeWCiNh6xRhDDc2yBV/IA_Expres_3_mini_negocios.png" alt="Mujer trabajando en su mini-negocio visual con IA desde su celular, tablet y laptop" className="w-full h-auto object-cover relative z-0" data-id="element-161" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-gold/20 rounded-full blur-2xl" data-id="element-162"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-blue-500/20 rounded-full blur-3xl" data-id="element-163"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}